module.exports = __webpack_public_path__ + "static/media/Romania.0ad242c0.png";